import styled from 'styled-components';

export const Alternative = styled.div`
  ${({ theme: { font } }) => font.t3};
  font-weight: 400;
  color: ${({ theme: { color } }) => color.ui2};
  text-align: center;
`;
